import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {defaults} from '../../../shared/constants/defaults';
import {NewResponsePayloadSet, NewsResponsePayload} from '../../../shared/models/api';
import {RequestNewsParams} from '../../../shared/models/news';
import {AppActions} from '../../actions';

export interface NewsState {
  latest: NewsResponsePayload[] | null;
  selection: NewsResponsePayload[];
  page: number;
  byId: NewResponsePayloadSet | null;
  from: string | null;
  to: string | null;
  moreNewsAvailable: boolean;
}

const initialState: NewsState = {
  latest: null,
  selection: [],
  page: 1,
  byId: null,
  from: null,
  to: null,
  moreNewsAvailable: false,
};

export const newsSlice = createSlice<NewsState, SliceCaseReducers<NewsState>>({
  name: '@@eskso/news',
  initialState,
  reducers: {
    setLatestNews: (state, action: PayloadAction<NewsResponsePayload[]>) => {
      state.latest = action.payload;
      state.selection = action.payload?.slice(0, defaults.newsPageSize);
    },
    setNews: (state, action: PayloadAction<NewsResponsePayload[]>) => {
      state.selection = action.payload;
    },
    setNewsById: (state, action: PayloadAction<NewResponsePayloadSet | null>) => {
      state.byId = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setDateRange: (state, action: PayloadAction<RequestNewsParams | null>) => {
      state.from = action.payload?.from ?? null;
      state.to = action.payload?.to ?? null;
    },
    setMoreNewsAvailable: (state, action: PayloadAction<boolean>) => {
      state.moreNewsAvailable = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const news = newsSlice.reducer;
